import { Role } from '~/common/providers/auth/role';

const financialSimulationAllowedRoles: Role[] = [
  'LOGLASS_SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'CORP_PLANNING',
];

export { financialSimulationAllowedRoles };
